export const MACHINEAPPS_SAVE_DISABLED_FLAG = 'machineapps_save_disabled';